import { camelCase } from 'lodash';
import { i18n } from 'next-i18next';

interface ProductCategory {
  name: string;
  categoryGroup?: { name: string };
}

interface ProductDriveType {
  name: string;
}

export const getGroupedProductCategoryTranslation = (productCategory: ProductCategory): { groupKey: string; optionKey: string } => {
  const optionKey = getProductCategoryTranslation(productCategory);

  return {
    groupKey: i18n?.t(`shared_productCategoryGroup_${camelCase(productCategory.categoryGroup?.name)}_label`, { ns: 'shared' }) || '',
    optionKey: optionKey || '',
  };
};

export const getProductCategoryTranslation = (productCategory?: ProductCategory) => {
  if (!productCategory?.name || !productCategory?.categoryGroup?.name) {
    return '';
  }

  const { name, categoryGroup } = productCategory;

  if (categoryGroup.name === name) {
    return i18n?.t(`shared_productCategory_${camelCase(name)}_label`, { ns: 'shared' }) || '';
  }

  return i18n?.t(`shared_productCategory_${camelCase(categoryGroup.name)}_${camelCase(name)}_label`, { ns: 'shared' }) || '';
};

export const productCategoryAndDriveType = (product: { productCategory?: ProductCategory; productDriveType?: ProductDriveType }) => {
  const category = getProductCategoryTranslation(product?.productCategory);

  return product?.productDriveType && product.productDriveType.name !== 'None'
    ? `${category} / ${i18n?.t(`shared_productDriveType_${camelCase(product.productDriveType.name)}_label`, { ns: 'shared' })}`
    : category;
};
